<div class="simple-modal-container">
    <div class="simple-modal-header">
        <mat-label> Find Your School, team or organization.</mat-label>
        <button type="button" class="close" (click)="closeDialog()">
            &times;
        </button>
    </div>

    <div class="simple-modal-body">
        <ng-select [items]="dimOrganizations" bindValue="name"
            placeholder="Search for schools, teams, associations & more…" [(ngModel)]="selectedOrganization" name="organizationName"
            [clearable]="true" [searchable]="true" (change)="onOrganizationSelect()" [searchFn]="customSearch" >
            <ng-template ng-option-tmp let-item="item">
              <div class="custom-option">
                <ng-container *ngFor="let part of splitName(item?.name)">
                  <span [ngClass]="{'highlight': part.toLowerCase() === selectedOrganization?.toLowerCase()}">{{ part }}</span>
                </ng-container>
                <div><strong>{{ cleanMascoText(item) }}</strong></div>
              </div>
            </ng-template>
        </ng-select>

    </div>
</div>


<!-- Confirmation Modal -->
<!-- <div *ngIf="showConfirmation" class="confirmation-modal">
    <div class="confirmation-modal-content">
        <mat-icon>warning</mat-icon>
        <p>Are you sure you want to add this organization?</p>
        <div class="confirmation-buttons">
            <button mat-button (click)="cancelSelection()">Cancel</button>
            <button mat-button color="primary" (click)="confirmSelection()">Continue</button>
        </div>
    </div>
</div> -->
<div *ngIf="showConfirmation" class="confirmation-modal">
    <div class="confirmation-modal-content">
        <mat-icon class="warning-icon">error_outline</mat-icon>
        <p>Are you sure you want to add this organization?</p>
        <div class="confirmation-buttons">
            <button mat-button class="cancel-button" (click)="cancelSelection()">Cancel</button>
            <button mat-button color="primary" class="continue-button" (click)="confirmSelection()">Continue</button>
        </div>
    </div>
</div>
